import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartFrame from "../../../ChartFrame";

const AgentServiceTimePerServiceLineGraph = ({ chart, title, height }) => {
  return (
    <>
      <ChartFrame height={height || "300px"} title={title}>
        <ResponsiveContainer>
          <LineChart
            data={chart}
            margin={{
              top: 0,
              right: 10,
              left: -10,
              bottom: 15,
            }}
            isAnimationActive={false}
          >
            <CartesianGrid stroke="#EBEBEB" vertical={false} />
            <XAxis
              dataKey="hour"
              name="Hour"
              axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
            />
            <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />
            <Tooltip />
            <Legend width="100%" />
            <Line
              type="monotone"
              strokeWidth={3}
              dataKey="hourlyAverage"
              name="Average Session Time"
              stroke={"var(--blue)"}
              dot={{ fill: "var(--blue)", r: 2 }}
              activeDot={{ r: 4 }}
              animationDuration={0}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartFrame>
    </>
  );
};

export default AgentServiceTimePerServiceLineGraph;
